import React, { useState, useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import firebase from "firebase";
import { AudioContext } from "../../contexts/AudioContext";
import { AuthContext } from "../../Auth";
import "./style.scss";

const Chart = (props) => {
  const audioContext = useContext(AudioContext);
  const authContext = useContext(AuthContext);
  const [isLoading, setLoading] = useState(false);
  const [loadText, setLoadText] = useState("");
  const [tableItems, setTableItem] = useState("");
  const [isRank, setRank] = useState(false);
  const db = firebase.firestore();
  const history = useHistory();
  const audio = new Audio(require("../../assets/audio/loading.mp3"));
  let position = 0;
  useEffect(() => {
    setLoading(true);
    setLoadText("LOADING RANK LIST...");
    audioContext.volumeDown();
    audio.volume = 0.5;
    audio.loop = true;
    audio.play();
    let docRef;
    if (props.location.state === "rank") {
      handleClickRank();
    } else {
      let tmp = [];
      docRef = db.collection("users").orderBy("score", "desc").limit(7);
      let i = 0;
      docRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          tmp[i] = doc.data();
          i++;
        });
        renderTable("top", tmp);
      });
    }
  }, []);
  const splitScore = (value) => {
    const integer = parseInt(value / 1);
    const decimal = parseFloat(value - integer).toFixed(3) * 1000;
    const score = [integer, decimal];
    return score;
  };
  const renderTable = (mode, data) => {
    const tableItems = [];
    let range;
    if (240 < data[3].score && data[3].score < 250) range = 7;
    else if (230 < data[3].score && data[3].score <= 240) range = 6;
    else if (220 < data[3].score && data[3].score <= 230) range = 5;
    else if (210 < data[3].score && data[3].score <= 220) range = 4;
    else if (200 < data[3].score && data[3].score <= 210) range = 3;
    else if (180 < data[3].score && data[3].score <= 200) range = 2;
    else if (160 < data[3].score && data[3].score <= 180) range = 1.2;
    else if (0 < data[3].score && data[3].score <= 160) range = 1;
    let rank =
      mode === "rank"
        ? parseFloat(localStorage.score) > 0
          ? parseInt(
              parseInt(localStorage.playedCount) /
                (240000 / (290000 - parseInt(data[3].score) * 1000)) /
                range
            )
          : parseInt(localStorage.playedCount)
        : 1;
    data.map((doc, i) => {
      if (doc.type === "b") {
        const storage = firebase.storage();
        const storageRef = storage.ref(`images/${doc.fileName}`);
        storageRef
          .getDownloadURL()
          .then((url) => {
            tableItems[i] = (
              <tr key={i}>
                <td>
                  {mode === "rank"
                    ? parseFloat(localStorage.score) < 250
                      ? rank + i + 1
                      : position + i + 1
                    : 1 + i}
                  .
                </td>
                <td>
                  <img alt={i} src={url} className="chart-body-avatar"></img>
                  <p className="chart-body-nickname">{doc.nickName}</p>
                </td>
                <td
                  style={{
                    display: "flex",
                    color: "rgba(255,255,255,0.5)",
                  }}
                >
                  <strong style={{ color: "#ffcc00", marginRight: "5px" }}>
                    {splitScore(doc.score)[0]}
                  </strong>{" "}
                  + {splitScore(doc.score)[1]}ms
                </td>
              </tr>
            );
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        tableItems[i] = (
          <tr key={i}>
            <td
              style={
                doc.email === localStorage.email
                  ? { color: "#ffcc00" }
                  : { color: "white" }
              }
            >
              {mode === "rank"
                ? parseFloat(localStorage.score) < 250
                  ? rank + i + 1
                  : position + i + 1
                : 1 + i}
              .
            </td>
            <td>
              <img alt={i} src={doc.photo} className="chart-body-avatar"></img>
              <p
                className="chart-body-nickname"
                style={
                  doc.email === localStorage.email
                    ? { color: "#ffcc00" }
                    : { color: "white" }
                }
              >
                {doc.nickName}
              </p>
            </td>
            <td
              style={{
                display: "flex",
                color: "rgba(255,255,255,0.5)",
              }}
            >
              <strong style={{ color: "#ffcc00", marginRight: "5px" }}>
                {splitScore(doc.score)[0]}
              </strong>
              + {splitScore(doc.score)[1]}ms
            </td>
          </tr>
        );
      }
    });
    setTimeout(() => {
      setLoading(false);
      setTableItem(tableItems);
      audio.pause();
      audio.currentTime = 0;
      if (mode === "top") {
        let audioCongrats = new Audio(require("../../assets/audio/top7.mp3"));
        audioCongrats.volume = 0.7;
        audioCongrats.play();
      }
      audioContext.volumeUp();
    }, 2000);
  };

  const getDate = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const tempDate = new Date();
    const weekNumber = Math.floor(tempDate.getDate() / 7);
    const date =
      monthNames[tempDate.getMonth()] +
      " " +
      tempDate.getFullYear() +
      " / week " +
      (weekNumber + 1);
    return date;
  };
  const handleClickStart = () => {
    const elem = document.getElementById("root");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
    if (authContext.currentUser) {
      db.collection("users")
        .doc(authContext.currentUser.email)
        .get()
        .then((doc) => {
          history.push("/profile");
        });
    } else {
      history.push("/signin");
    }
  };
  const handleClickRank = async () => {
    setLoading(true);
    setLoadText("LOADING RANK LIST...");
    setRank(true);
    audioContext.volumeDown();
    audio.play();
    let i = 0;
    let docData = [];
    let docRef;
    if (parseFloat(localStorage.score) >= 250) {
      let temp = [];
      await db
        .collection("users")
        .orderBy("score", "desc")
        .limit(7)
        .get()
        .then((querySnapshot) => {
          let isTop = false;
          querySnapshot.forEach((doc) => {
            if (doc.data().email === localStorage.email) isTop = true;
          });
          if (isTop) {
            querySnapshot.forEach((doc) => {
              docData[i] = doc.data();
              i++;
            });
            renderTable("rank", docData);
          } else {
            db.collection("users")
              .where("score", ">=", parseInt(localStorage.score) - 5)
              .orderBy("score", "desc")
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  temp[i] = doc.data();
                  if (doc.data().email === localStorage.email) position = i;
                  i++;
                });
                if (position > 2) {
                  docData[0] = temp[position - 3];
                  docData[1] = temp[position - 2];
                  docData[2] = temp[position - 1];
                  docData[3] = temp[position];
                  docData[4] = temp[position + 1];
                  docData[5] = temp[position + 2];
                  docData[6] = temp[position + 3];
                } else if (position === 2) {
                  docData[0] = temp[position - 2];
                  docData[1] = temp[position - 1];
                  docData[3] = temp[position];
                  docData[4] = temp[position + 1];
                  docData[5] = temp[position + 2];
                  docData[6] = temp[position + 3];
                  docData[6] = temp[position + 4];
                } else if (position === 1) {
                  docData[0] = temp[position - 1];
                  docData[3] = temp[position];
                  docData[4] = temp[position + 1];
                  docData[5] = temp[position + 2];
                  docData[6] = temp[position + 3];
                  docData[6] = temp[position + 4];
                  docData[6] = temp[position + 5];
                } else if (position === 0) {
                  docData[3] = temp[position];
                  docData[4] = temp[position + 1];
                  docData[5] = temp[position + 2];
                  docData[6] = temp[position + 3];
                  docData[6] = temp[position + 4];
                  docData[6] = temp[position + 5];
                  docData[6] = temp[position + 6];
                }
                setTimeout(() => {
                  renderTable("rank", docData);
                }, 2000);
              });
          }
        });
    } else {
      docRef = db
        .collection("users")
        .where("score", "<", parseFloat(localStorage.score))
        .orderBy("score", "desc")
        .limit(3);
      await docRef.get().then(async (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          docData[i] = doc.data();
          i++;
        });
        docRef = db
          .collection("users")
          .where("score", ">=", parseFloat(localStorage.score))
          .orderBy("score")
          .limit(4);
        await docRef.get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            docData[i] = doc.data();
            i++;
          });
          docData.sort((a, b) => {
            return b.score - a.score;
          });
          setTimeout(() => {
            renderTable("rank", docData);
          }, 2000);
        });
      });
    }
  };

  const handleClickTop = async () => {
    audioContext.volumeDown();
    audio.play();
    setRank(false);
    setLoading(true);
    setLoadText("LOADING RANK LIST...");
    audioContext.volumeDown();
    const docRef = db.collection("users").orderBy("score", "desc").limit(7);
    let i = 0;
    let tmp = [];
    await docRef.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        tmp[i] = doc.data();
        i++;
      });
      setTimeout(() => {
        renderTable("top", tmp);
      }, 2000);
    });
  };

  return (
    <>
      {isLoading ? (
        <div className="loader-container">
          <img
            alt="loader"
            src={require(`../../assets/images/SVG/1.svg`)}
            className="loader"
          ></img>
          <div>{loadText}</div>
        </div>
      ) : (
        ""
      )}
      <div
        className="chart"
        style={isLoading ? { opacity: 0 } : { opacity: 1 }}
      >
        <img
          alt="logo"
          src={require("./../../assets/images/logo.svg")}
          className="chart-logo"
        ></img>
        <div className="chart-header">
          <div className="chart-header-title">Lucky chart</div>
          <div className="chart-header-date">{getDate()}</div>
        </div>
        <div className="chart-body">
          <table className="chart-body-table">
            <tr>
              <th>Position</th>
              <th>Player</th>
              <th>Lucky Score</th>
            </tr>
            {isLoading ? "" : <div>{tableItems}</div>}
          </table>
          <div className="chart-body-btnGroup">
            {authContext.currentUser ? (
              isRank ? (
                <button
                  className="chart-body-btnGroup-button-rank"
                  onClick={handleClickTop}
                >
                  SHOW TOP 7
                </button>
              ) : (
                <button
                  className="chart-body-btnGroup-button-rank"
                  onClick={handleClickRank}
                >
                  SHOW MY RANK
                </button>
              )
            ) : (
              ""
            )}
            <button
              className="chart-body-btnGroup-button"
              onClick={handleClickStart}
            >
              {authContext.currentUser ? "MY PROFILE" : "START GAME"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
export default Chart;
